var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2929 18.1131C22.5616 18.3827 22.7631 18.7118 22.8809 19.0738C22.9988 19.4358 23.0297 19.8204 22.9713 20.1965C22.9128 20.5727 22.7666 20.9298 22.5444 21.2389C22.3223 21.548 22.0305 21.8005 21.6926 21.9759C19.7619 23.0078 17.5124 23.2715 15.3954 22.7141C9.7766 21.2997 1.70033 13.2234 0.285861 7.60462C-0.271504 5.48758 -0.00777537 3.23808 1.02414 1.30736C1.19951 0.969505 1.45198 0.677693 1.7611 0.455557C2.07023 0.233422 2.42732 0.0872068 2.80347 0.0287524C3.17962 -0.029702 3.56424 0.00124719 3.9262 0.119094C4.28816 0.236941 4.61728 0.438372 4.88691 0.707078L7.28461 3.10362C7.63038 3.44592 7.86435 3.88493 7.9557 4.36282C8.04705 4.84072 7.99149 5.33507 7.79634 5.78076C7.5828 6.28082 7.27958 6.73759 6.90167 7.12853C4.16013 9.87007 13.1311 18.841 15.8715 16.0983C16.2625 15.7191 16.7197 15.4147 17.2204 15.2002C17.666 15.0047 18.1605 14.949 18.6384 15.0404C19.1164 15.1317 19.5554 15.3659 19.8975 15.7119L22.2929 18.1131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.eabb130c29f2ae6a03861e13521a5019.svg";
export { ForwardRef as ReactComponent };